import { Link, useLocation } from "wouter";
import { ArrowLeft, Award, Building2, ClipboardList, Handshake, LayoutDashboard, Megaphone, ShieldCheck } from "lucide-react";

/**
 * Section navigation for the operations workspace.
 *
 * The dashboard at /operations has a sidebar, but the pages beneath it did not
 * — Vendors, Coaches and the Audit log render inside the public site layout,
 * and the Blueprint desk has no surrounding chrome at all. Staff who landed on
 * one of those had no way back other than the browser's back button or editing
 * the URL.
 *
 * This is deliberately a full section list rather than a single back link:
 * moving between Vendors and Coaches is at least as common as returning to the
 * overview, and routing every such move through the dashboard is a wasted step.
 */
const OPS_SECTIONS = [
  { label: "Overview", path: "/operations", icon: LayoutDashboard },
  { label: "Clients", path: "/operations/clients", icon: Building2 },
  { label: "Blueprints", path: "/operations/blueprints", icon: ClipboardList },
  { label: "Vendors", path: "/operations/vendors", icon: Handshake },
  { label: "Coaches", path: "/operations/coaches", icon: Award },
  { label: "FitLife-X", path: "/operations/fitlife", icon: Megaphone },
  { label: "Audit log", path: "/operations/audit", icon: ShieldCheck },
];

export function OpsNav() {
  const [location] = useLocation();

  return (
    <nav className="ops-nav" aria-label="Operations sections">
      <div className="ops-nav__inner">
        <Link href="/operations" className="ops-nav__back">
          <ArrowLeft size={15} />
          <span>Operations</span>
        </Link>

        <ul className="ops-nav__links">
          {OPS_SECTIONS.map(section => {
            const current = location === section.path;
            return (
              <li key={section.path}>
                <Link
                  href={section.path}
                  className={current ? "is-current" : undefined}
                  // aria-current tells a screen reader which section is open —
                  // the colour change alone does not convey that.
                  aria-current={current ? "page" : undefined}
                >
                  <section.icon size={14} />
                  <span>{section.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
